import React, { useEffect, useState } from "react";
import { useCart } from "../context/CartContext";
import { PhotoGallery } from "./PhotoGallery";
import { ShoppingBag, Check } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

export const BodegaRacks = () => {
  const { addItem } = useCart();
  const [products, setProducts] = useState([]);
  const [addedId, setAddedId] = useState("");

  useEffect(() => {
    fetch(`${API}/api/bodega/products`)
      .then((r) => r.json())
      .then((d) => setProducts(d.products || []))
      .catch(() => {});
  }, []);

  if (products.length === 0) return null;

  const add = (p) => {
    addItem({
      id: p.lookup_key,
      name: p.size_label ? `${p.name} — ${p.size_label}` : p.name,
      price: p.price,
      image: (p.photos || [])[0] || "",
      description: p.description || p.name,
      tag: "bodega",
    });
    setAddedId(p.id);
    setTimeout(() => setAddedId(""), 1600);
  };

  return (
    <section className="bodega-racks" data-testid="bodega-racks">
      <h2 className="bodega-racks-title">The racks</h2>
      <div className="bodega-racks-grid">
        {products.map((p) => (
          <article className="bodega-rack-card" key={p.id} data-testid={`bodega-card-${p.id}`}>
            {(p.photos || []).length > 0 && (
              <PhotoGallery images={p.photos} alt={p.name} testId={`bodega-gallery-${p.id}`} />
            )}
            <div className="bodega-rack-info">
              <div className="brand-preorder-name">{p.name}</div>
              {p.size_label && <div className="brand-preorder-color">Size — {p.size_label}</div>}
              {p.description && <div className="bodega-rack-desc">{p.description}</div>}
              <div className="brand-preorder-price" data-testid={`bodega-price-${p.id}`}>${p.price}</div>
              {p.sold ? (
                <div className="bodega-sold-badge" data-testid={`bodega-sold-${p.id}`}>SOLD</div>
              ) : (
                <button
                  type="button"
                  className="btn-solid"
                  onClick={() => add(p)}
                  data-testid={`bodega-add-${p.id}`}
                >
                  {addedId === p.id ? (
                    <><Check size={16} /> Added</>
                  ) : (
                    <><ShoppingBag size={16} /> Add to cart</>
                  )}
                </button>
              )}
            </div>
          </article>
        ))}
      </div>
    </section>
  );
};
